// Company detail/read endpoints against /api/company
import { apiRoutes } from "../../../_config/apiRoutes";
import { apiSlice } from "../../../_api/apiSlice";

export const companyDetailsApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getCompanyById: builder.query({
      query: ({ id }) => ({
        url: `company/customers/${id}`,
        method: "GET",
      }),
      providesTags: (result, error, arg) => [
        { type: "Company", id: arg?.id },
      ],
    }),
    getAllCompanyMetrics: builder.query({
      query: ({ companyId, orgId }) => ({
        url: `${apiRoutes.company.getAllCompanyMetrics.path}/${companyId}/metrics`,
        method: apiRoutes.company.getAllCompanyMetrics.reqType,
        params: orgId ? { orgId } : undefined,
      }),
      providesTags: (result, error, arg) => [
        { type: "Company", id: `metrics-${arg?.companyId}` },
      ],
    }),
    getCompanyContactsById: builder.query({
      query: (params) => ({
        url: "company/customers/contacts",
        method: "GET",
        params,
      }),
      providesTags: (result, error, arg) => [
        { type: "Company", id: `contacts-${arg?.id}` },
      ],
    }),
    getAllCompanyContactsById: builder.query({
      query: (params) => ({
        url: "company/customers/contacts/all",
        method: "GET",
        params,
      }),
      providesTags: (result, error, arg) => [
        { type: "Company", id: `contacts-all-${arg?.id}` },
      ],
    }),
  }),
});

export const {
  useGetCompanyByIdQuery,
  useGetAllCompanyMetricsQuery,
  useGetCompanyContactsByIdQuery,
  useGetAllCompanyContactsByIdQuery,
} = companyDetailsApi;

// Subscriptions-by-company now lives in the migrated, tagged
// _features/subscriptions/api/subscriptionApi.js (was the legacy untagged
// subscriptionApiSlice before the Subscriptions migration). Re-exported
// under its old hook name so CompanyOverview/CompanyDetails don't need an
// import-name change, just the source.
export { useGetSubscriptionsByCompanyQuery as useGetAllCompanySubscriptionsQuery } from "../../../_features/subscriptions/api/subscriptionApi";
